/**
 *
 */
;
(function ($, window, document) {

    "use strict";

    var pluginName = "responsiveLazyLoader",
        defaults = {

        distance: 0, // the distance (in pixels) between the image and active window for loading the actual image
        force: false, // force images loading without distance
        scroll: true, // consider scrolling
        resize: true, // consider resizing
        loader: false, // show laoder
        token: '[[display]]', // token to be replaced by media query key

        // media queries key -> query
        mediaQueries: {
            'm': "(max-width: 480px)", // phone
            'm@2x': "(max-width: 480px) and (-webkit-min-device-pixel-ratio: 2)", // phone-retina
            't': "(min-width: 481px) and (max-width: 991px)", // tablet
            't@2x': "(min-width: 481px) and (max-width: 991px) and (-webkit-min-device-pixel-ratio: 2)", // tablet-retina
            'd': "(min-width: 992px)", // desktop
            'd@2x': "(min-width: 992px) and (-webkit-min-device-pixel-ratio: 2)" // desktop-retina
        },

        defaultMediaQueryKey: 'd',

        // triggered before images are lazy loaded
        beforeLoading: function beforeLoading() {},

        // triggered when all images are loaded
        complete: function complete() {},

        // triggered when all images in the current view port are loaded
        viewportComplete: function viewportComplete() {},

        // triggered when plugin was initialzied
        initialized: function initialized() {},

        identifier: null

    };

    function ResponsiveLazyLoader(element, options, callback) {
        this.element = $(element);
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.callback = callback;

        //console.log(this.settings);

        this.init();
    }

    $.extend(ResponsiveLazyLoader.prototype, {

        init: function init() {

            var that = this;

            if (!this.getCache('currentMediaQueryKey')) {
                this.setCache('currentMediaQueryKey', this.getCurrentMediaQueryKey());
            }

            that.load();

            if (this.settings.scroll) {
                $(window).bind('scroll', function () {
                    that.refresh();
                });
            }

            if (this.settings.resize) {
                $(window).resize(Util.throttle(function () {
                    that.setCache('mediaQueryDetection', true);
                    that.refresh();
                }, 50));
            }
        },

        refresh: function refresh() {
            var current = this.getCurrentMediaQueryKey();
            if (this.getCache('currentMediaQueryKey') != current) {
                this.setCache('currentMediaQueryKey', current);
            }
            this.load();
        },

        getCurrentMediaQueryKey: function getCurrentMediaQueryKey() {

            if (this.getCache('mediaQueryDetection')) {

                //console.log('check');

                var that = this,
                    queryKey = this.settings.defaultMediaQueryKey;
                $.each(this.settings.mediaQueries, function (key, value) {
                    if (that.isMatchingMediaQuery(value)) {
                        queryKey = key;
                    }
                });

                this.setCache('mediaQueryDetection', false);
            } else {
                queryKey = this.getCache('currentMediaQueryKey');
            }

            return queryKey;
        },

        isMatchingMediaQuery: function isMatchingMediaQuery(mediaQuery) {
            if ('matchMedia' in window) {
                return window.matchMedia(mediaQuery).matches;
            } else if (Modernizr) {
                return Modernizr.mq(mediaQuery);
            }
            return false;
        },

        shouldBeLoaded: function shouldBeLoaded() {

            if (this.settings.force || this.elementHasAttribute('data-force-loading')) {
                return true;
            }

            if (this.preventLoading()) {
                return false;
            }

            // cache $(window).height()

            var windowTop = $(window).scrollTop() - this.settings.distance,
                windowBottom = windowTop + $(window).height() + this.settings.distance * 2,
                elementTop = this.element.offset().top - this.settings.distance,
                elementBottom = elementTop + this.element.height() + this.settings.distance;

            return elementBottom >= windowTop && elementTop <= windowBottom;
        },

        preventLoading: function preventLoading() {

            return this.element.hasClass('prevent-loading-' + this.getCache('currentMediaQueryKey').charAt(0));
        },

        load: function load() {

            if (!this.elementHasAttribute('data-media-query')) {
                this.element.attr('data-media-query', this.getCache('currentMediaQueryKey'));
            }

            var mediaQueryChange = this.getCache('currentMediaQueryKey') != this.element.attr('data-media-query');

            if (!this.element.hasClass('loaded') || mediaQueryChange) {

                // should be loaded is very cpu intensive so do it only if really needed
                if (this.shouldBeLoaded() || mediaQueryChange) {

                    if (typeof this.settings.beforeLoading == 'function') {
                        this.settings.beforeLoading.call(this, this.element);
                    }

                    var that = this,
                        isImage = this.element.is('img'),
                        isLink = this.element.is('a'),
                        targetAttribute = this.elementHasAttribute('data-target-attribute') ? this.element.attr('data-target-attribute') : isLink ? 'href' : 'src',
                        sourceAttribute = this.elementHasAttribute('data-src') ? 'data-src' : this.elementHasAttribute('data-src-ll') ? 'data-src-ll' : false;

                    if (sourceAttribute !== false) {

                        var targetSrc = this.element.attr(sourceAttribute).replace(this.settings.token, this.getCache('currentMediaQueryKey'));

                        this.element
                        //.css('visibility', 'hidden') -- flicker
                        .one('load', function (e) {
                            // is called when image was loaded
                            //console.log('image was loaded', e);

                            if (that.element.data('triggerParent')) {
                                that.element.parents(that.element.data('triggerParent')).addClass('loaded');
                            }

                            that.element
                            //.css('visibility', 'visible')
                            .addClass('loaded').attr('data-media-query', that.getCache('currentMediaQueryKey'));

                            // remove spinner in case there is one
                            that.element.parent().removeClass('spinner');

                            if (typeof that.callback == 'function') {
                                that.callback.call();
                            }
                        });

                        if (this.element.attr('data-src') || this.element.attr('data-src-ll')) {
                            if (isImage || isLink) {
                                this.element.attr(targetAttribute, targetSrc);
                            } else {

                                // idea create regular img to catch load evant
                                var dummyImage = $('<img style="display: none"/>').attr('src', targetSrc).load(function () {
                                    that.element.trigger('load');
                                    //  dummyImage.remove();
                                });

                                this.element.css('background-image', 'url(' + targetSrc + ')').after(dummyImage);
                            }
                            if (targetAttribute != 'src') {
                                that.element.trigger('load');
                            }
                        }
                    }
                }
            }
        },

        elementHasAttribute: function elementHasAttribute(name) {
            return typeof this.element.attr(name) !== 'undefined' && this.element.attr(name) !== false;
        },

        getCache: function getCache(key) {
            return window.responsiveLazyLoader[this.settings.identifier][key];
        },

        setCache: function setCache(key, value) {
            window.responsiveLazyLoader[this.settings.identifier][key] = value;
        }

    });

    $.fn[pluginName] = function (options) {

        // init global storage for caching
        window.responsiveLazyLoader = window.responsiveLazyLoader || {};
        window.responsiveLazyLoader['count'] = window.responsiveLazyLoader['count'] || 0;
        options = options || {};

        // define cache keys and general settings
        window.responsiveLazyLoader['count']++;
        options.identifier = 'group' + window.responsiveLazyLoader['count'];
        window.responsiveLazyLoader[options.identifier] = window.responsiveLazyLoader[options.identifier] || {};
        window.responsiveLazyLoader[options.identifier]['mediaQueryDetection'] = true;

        var elementsCount = this.length,
            elementsLoadedCount = this.length;

        return this.each(function () {

            if (!$.data(this, "plugin_" + pluginName)) {

                $.data(this, "plugin_" + pluginName, new ResponsiveLazyLoader(this, options, function () {

                    //console.log(elementsLoadedCount);

                    if (! --elementsLoadedCount) {
                        if (options) {
                            if (typeof options.complete == 'function') {
                                options.complete.call();
                            }
                        }
                    }
                }));

                if (! --elementsCount) {
                    if (options) {
                        if (typeof options.initialized == 'function') {
                            options.initialized.call();
                        }
                    }
                }
            }
        });
    };
})(jQuery, window, document);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function ($) {

	"use strict";

	var Typeahead = function Typeahead(element, options) {
		this.$element = $(element);
		this.options = $.extend({}, $.fn.typeahead.defaults, options);
		this.matcher = this.options.matcher || this.matcher;
		this.sorter = this.options.sorter || this.sorter;
		this.highlighter = this.options.highlighter || this.highlighter;
		this.updater = this.options.updater || this.updater;
		this.$menu = $(this.options.menu).appendTo('body');
		this.source = this.options.source;
		this.shown = false;
		this.listen();
	};

	Typeahead.prototype = {
		constructor: Typeahead,
		select: function select(e) {
			var val = this.$menu.find('.active');
			this.$element.val(this.updater(val, e)).change();
			return this.hide();
		},
		updater: function updater(item, e) {
			return item;
		},
		show: function show() {
			this.$menu.show();
			this.shown = true;
			return this;
		},
		hide: function hide() {
			this.$menu.hide();
			this.shown = false;
			return this;
		},
		lookup: function lookup(event) {
			var items;
			this.query = this.$element.val();
			if (!this.query || this.query.length < this.options.minLength) {
				return this.shown ? this.hide() : this;
			}
			items = $.isFunction(this.source) ? this.source(this.query, $.proxy(this.process, this)) : this.source;
			return items ? this.process(items) : this;
		},
		process: function process(items) {
			// track search on each result refresh
			trackSearch(this.query);
			this.itemCount = items.length;
			var that = this;
			items = $.grep(items, function (item) {
				return that.matcher(item);
			});
			items = this.sorter(items);
			if (items.length == 0) {
				this.noresult().show();
				return this;
				//return this.shown ? this.hide() : this
			}
			return this.render(items.slice(0, this.options.items)).show();
		},
		matcher: function matcher(item) {
			return ~item[this.options.valueKey].toLowerCase().indexOf(this.query.toLowerCase());
		},
		sorter: function sorter(items) {
			var beginswith = [],
			    caseSensitive = [],
			    caseInsensitive = [],
			    item;
			while (item = items.shift()) {
				if (!item[this.options.valueKey].toLowerCase().indexOf(this.query.toLowerCase())) beginswith.push(item);else if (~item[this.options.valueKey].indexOf(this.query)) caseSensitive.push(item);else caseInsensitive.push(item);
			}
			return beginswith.concat(caseSensitive, caseInsensitive);
		},
		highlighter: function highlighter(item) {
			var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
			return item.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
				return '<strong>' + match + '</strong>';
			});
		},
		render: function render(items) {
			var that = this;
			items = $(items).map(function (i, item) {
				var i = $(that.options.item);
				var html = i.html();
				$.each(item, function (key, value) {
					i.attr('data-' + key, value);
					html = html.replace('{' + key + '}', value);
				});
				i.html(html);
				return i[0];
			});
			items.first().addClass('active');

			this.$menu.html(items);

			/* begin: removed condition for test purpose */
			//			if (this.itemCount > that.options.items) {
			//				this.$menu.append(that.options.more)
			//			}
			this.$menu.append(that.options.more);
			/* end: removed condition for test purpose */

			return this;
		},
		noresult: function noresult() {
			var html = '<div class="no-result">' + this.options.noresultText + '</div>';
			this.$menu.html(html);
			return this;
		},
		next: function next(event) {
			var active = this.$menu.find('.active').removeClass('active'),
			    next = active.next();
			if (!next.length) {
				next = $(this.$menu.find('li')[0]);
			}
			next.addClass('active');
		},
		prev: function prev(event) {
			var active = this.$menu.find('.active').removeClass('active'),
			    prev = active.prev();
			if (!prev.length) {
				prev = this.$menu.find('li').last();
			}
			prev.addClass('active');
		},
		listen: function listen() {
			this.$element.on('blur', $.proxy(this.blur, this)).on('keypress', $.proxy(this.keypress, this)).on('keyup', $.proxy(this.keyup, this));
			if ($.browser.chrome || $.browser.webkit || $.browser.msie) {
				this.$element.on('keydown', $.proxy(this.keydown, this));
			}
			this.$menu.on('click', $.proxy(this.click, this)).on('mouseenter', 'li', $.proxy(this.mouseenter, this));
		},
		move: function move(e) {
			if (!this.shown) return;
			switch (e.keyCode) {
				case 9: // tab
				case 13: // enter
				case 27:
					// escape
					e.preventDefault();
					break;
				case 38:
					// up arrow
					e.preventDefault();
					this.prev();
					break;
				case 40:
					// down arrow
					e.preventDefault();
					this.next();
					break;
			}
			e.stopPropagation();
		},
		keydown: function keydown(e) {
			this.suppressKeyPressRepeat = !~$.inArray(e.keyCode, [40, 38, 9, 13, 27]);
			this.move(e);
		},
		keypress: function keypress(e) {
			if (this.suppressKeyPressRepeat) return;
			this.move(e);
		},
		keyup: function keyup(e) {
			switch (e.keyCode) {
				case 40: // down arrow
				case 38:
					// up arrow
					break;
				case 9: // tab
				case 13:
					// enter
					if (!this.shown) return;
					this.select(e);
					break;
				case 27:
					// escape
					if (!this.shown) return;
					this.hide();
					break;
				default:
					this.lookup();
			}
			e.stopPropagation();
			e.preventDefault();
		},
		blur: function blur(e) {
			var that = this;
			setTimeout(function () {
				that.hide();
			}, 150); //leave this to 150! changing this amount will cause a f****** runtime error!!!
		},
		click: function click(e) {
			e.stopPropagation();
			e.preventDefault();
			this.select(e);
		},
		mouseenter: function mouseenter(e) {
			this.$menu.find('.active').removeClass('active');
			$(e.currentTarget).addClass('active');
		}
	};

	$.fn.typeahead = function (option) {
		return this.each(function () {
			var $this = $(this),
			    data = $this.data('typeahead'),
			    options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
			if (!data) $this.data('typeahead', data = new Typeahead(this, options));
			if (typeof option == 'string') data[option]();
		});
	};

	$.fn.typeahead.defaults = {
		source: [],
		valueKey: 'value',
		items: 8,
		menu: '<ul class="typeahead dropdown-menu"></ul>',
		item: '<li><a href="#">{value}</a></li>',
		noresultText: 'no result',
		minLength: 1
	};

	$.fn.typeahead.Constructor = Typeahead;
	$(function () {
		$('body').on('focus.typeahead.data-api', '[data-provide="typeahead"]', function (e) {
			var $this = $(this);
			if ($this.data('typeahead')) return;
			e.preventDefault();
			$this.typeahead($this.data());
		});
	});
}(window.jQuery);

// search more link
var searchQuery = '';
function getSearchMoreUrl() {
	var url = jQuery('#search-box').data('moreurl');
	var query = jQuery('#search-box').data('value');
	if (query != '') {
		url = Util.addParameter(Util.addParameter(url, 'q', encodeURI(query)), 't', 'global');
	}
	return url;
}

// tracking
var trackSearch = Util.throttle(function (query) {
	if (query && query != '') {
		Track.page(Util.addParameter(Util.addParameter(window.location.pathname + window.location.search, 'q', encodeURI(query)), 't', 'global'));
	}
}, 1000);

var foundSuccess = false;
(function ($) {
	$(function () {
		var fetchResults = Util.throttle(function (query, obj) {
			var wwwDomain = Util.isWwwPage() ? '' : Util.getWwwDomain(),
			    endpoint = wwwDomain + "/typo3conf/ext/elasticsearch/proxy.php?t=product&l=" + Util.getLang();
			$.ajax({
				url: endpoint,
				type: "GET",
				dataType: "jsonp",
				data: 'q=' + query,
				success: function success(data) {
					var hits = [];
					if (data.total > 0) {
						for (var i = 0; i < data.hits.length; i++) {
							hits[i] = data.hits[i];
							if (hits[i].description.length > 55) {
								hits[i].description = hits[i].description.replace(/^(.{55}[^\s]*).*/, "$1") + "…";
							}
							// ensure that all urls point to the www
							hits[i].packshot = wwwDomain + hits[i].packshot;
							hits[i].packshot_flyout = wwwDomain + '/' + hits[i].packshot_flyout;
							hits[i].page = wwwDomain + hits[i].page;
							hits[i].purchase = wwwDomain + hits[i].purchase;
						}
					}
					obj(hits);
				}
			});
		}, 200);
		$('#search-box').typeahead({
			valueKey: 'title',
			items: 7,
			menu: '<ul id="searchDropDown" class="typeahead dropdown-menu search"></ul>',
			item: '<li><a href="{page}"><span class="packshot"><span class="packshot-align"><img src="{packshot_flyout}" /></span></span><span class="description"><span class="title">{title}</span><br><span class="headline">{description}</span></span></a></li>',
			more: '<li class="more-results" data-page="more"><a href="#" class="more-results-link">' + jQuery('#search-box').data('moretext') + '</a></li>',
			noresultText: jQuery('#search-box').data('noresulttext'),
			source: fetchResults,
			matcher: function matcher(item) {
				return true;
			},
			// starts after selecting search result
			updater: function updater(item, e) {
				// check for search results and only then go to url
				if (item.length > 0) {
					foundSuccess = true;
					$('body,a,button').css('cursor', 'wait');
					var url = item.data('page');
					if (item.data('page') == 'more') {
						url = getSearchMoreUrl();
					}
					if (e.shiftKey && item.data('purchase') != '') {
						url = item.data('purchase');
					}
					Util.goToUrl(url);
					return item.data('title');
				} else {
					if (!Util.isMobile()) {
						Util.goToUrl('/' + Util.getLang() + '/products/');
					}
				}
			}
		});

		// toggle input placeholder-text on focus/on leave
		//$('#search-box').val($('#search-box').data('placeholder'))
		$('#search-box').on('click focusin', function () {
			$(this).attr('value', '');
		}).on('keyup', function () {
			$(this).data('value', $(this).attr('value'));
		}).on('focusout', function () {
			// reset
			if (!foundSuccess) {
				$('#search-box').val('');
			}
		});

		// toggle mobile search field when magnifying glass icon clicked
		var focused = jQuery('#mobile-product-search-input'),
		    mobileSearchBtn = jQuery('#login-cart-search .search-link'),
		    mobileSearch = jQuery('#mobile-product-search-container');

		mobileSearchBtn.data('exclusive_popover', { $tip: mobileSearch });

		function mobileSearchHandler() {
			if (mobileSearchBtn.hasClass('dropped')) {
				mobileSearchBtn.trigger($.Event('show.bs.popover'));
			}

			mobileSearch.toggle().toggleClass('in');

			if (mobileSearch.hasClass('in')) {
				focused.trigger('touchstart');
			} else {
				focused.trigger('touchend');
			}

			mobileSearchBtn.toggleClass('dropped');
		}

		mobileSearchBtn.on('click', function (e) {
			e.preventDefault();
			mobileSearchHandler();
		});

		focused.on('touchstart', function () {
			$(this).focus();
		});
		focused.on('touchend', function () {
			$(this).blur();
		});

		/**
   * Search popover
   */

		$('#search-link-desktop').popover({
			placement: 'bottom',
			html: true,
			animation: false,
			content: $('#top-search-dropdown'),
			template: '<div class="popover"><div class="arrow"></div><div class="popover-inner"><div class="popover-content"></div></div></div>'
		}).exclusivePopover({ group: 'metanav' }).on('click', function () {
			return false;
		}).on('shown.bs.popover', function () {
			$('#search-box').focus();
		});

		$('#search-box').on('click', function (event) {
			event.stopPropagation();
		});

		mobileSearchBtn.exclusivePopover({ group: 'metanav', onHide: function onHide() {
				if (mobileSearchBtn.hasClass('dropped')) {
					mobileSearchBtn.trigger('click');
				}
			} });
	});
})(jQuery);
(function ($) {
    $(function () {

        /**
         * Footer Social Counts
         */

        /* Facebook */
        $('.connect-facebook').on('click', function (e) {
            e.preventDefault();

            $('.connect-twitter-menu').hide();

            $([{
                account: 'nativeinstruments',
                cssID: '#facebook-ni-count',
                toggle: false
            }, {
                account: 'nikomplete',
                cssID: '#facebook-komplete-count',
                toggle: false
            }, {
                account: 'traktorpro',
                cssID: '#facebook-traktor-count',
                toggle: false
            }, {
                account: 'nimaschine',
                cssID: '#facebook-maschine-count',
                toggle: false
            }, {
                account: 'playstems',
                cssID: '#facebook-stems-count',
                toggle: true
            }, {
                account: 'nativeinstrumentsjapan',
                cssID: '#facebook-tokyo-count',
                toggle: false
            }]).each(function (index, elm) {
                $.ajax({
                    url: Util.getWwwDomain() + '/typo3conf/ext/ni_assets/Resources/Public/Scripts/facebookProxy.php?account=' + elm.account,
                    dataType: 'jsonp',
                    success: function success(data) {
                        $(elm.cssID).text(data.likes ? Util.formatCount(data.likes) + ' Likes' : '');
                        if (elm.toggle) {
                            $('.connect-facebook-menu').toggle();
                        }
                    }
                });
            });
        });

        /* Twitter */
        $('.connect-twitter').on('click', function (e) {
            e.preventDefault();

            $('.connect-facebook-menu').hide();

            $([{
                account: 'tokyo_ni',
                cssID: '#twitter-tokyo-count',
                toggle: false
            }, {
                account: 'NI_News',
                cssID: '#twitter-news-count',
                toggle: false
            }, {
                account: 'Komplete',
                cssID: '#twitter-komplete-count',
                toggle: false
            }, {
                account: 'Traktor',
                cssID: '#twitter-traktor-count',
                toggle: false
            }, {
                account: 'NI_Maschine',
                cssID: '#twitter-maschine-count',
                toggle: false
            }, {
                account: 'NI_Job',
                cssID: '#twitter-jobs-count',
                toggle: true
            }]).each(function (index, elm) {
                $.ajax({
                    url: Util.getWwwDomain() + '/typo3conf/ext/ni_assets/Resources/Public/Scripts/twitterProxy.php?url=' + encodeURIComponent('users/show.json?screen_name=' + elm.account),
                    dataType: 'jsonp',
                    success: function success(data) {
                        $(elm.cssID).text(data.followers_count ? Util.formatCount(data.followers_count) + ' Followers' : '');
                        if (elm.toggle) {
                            $('.connect-twitter-menu').toggle();
                        }
                    }
                });
            });
        });
    });
})(jQuery);
/*
 * Konami Code For jQuery Plugin
 * 1.2.1, 23 October 2013
 *
 * Using the Konami code, easily configure and Easter Egg for your page or any element on the page.
 *
 * Copyright 2011 - 2013 Tom McFarlin, http://tommcfarlin.com
 * Released under the MIT License
 */(function(e){"use strict";e.fn.konami=function(t){var n,r,i,s;n=e.extend({},e.fn.konami.defaults,t);return this.each(function(){i=[];e(window).keyup(function(e){s=e.keyCode||e.which;if(n.code.length>i.push(s)){return}if(n.code.length<i.length){i.shift()}if(n.code.toString()!==i.toString()){return}n.cheat()})})};e.fn.konami.defaults={code:[38,38,40,40,37,39,37,39,66,65],cheat:null}})(jQuery)
jQuery(window).konami({
    code: [38, 40, 37, 39], // up down left right
    //code: [38, 40], // up up down down left left right right
    cheat: function cheat() {

        $('head').append('<link rel="stylesheet" href="/typo3conf/ext/ni_assets/Resources/Public/Css/credits.css" type="text/css" />');

        var names = ['Thomas Brandl', 'Andreas Gloggengiesser', 'Marc Eilhard', 'Konrad Gmurek', 'Jascha Dachtera', 'Björn Schmitt', 'Michael Sohn', 'Joachim Landesvatter', 'Fabian Kurz', 'Christoph Zahn', 'Stanislav Kopp', 'Marcus Hanisch', 'Stanislav Filippov', 'Daniel Wedewardt'];

        function shuffle(array) {
            var currentIndex = array.length,
                temporaryValue,
                randomIndex;
            while (0 !== currentIndex) {
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }
            return array;
        }

        var lines = ['<span>MADE WITH ♥ BY</span>'].concat(shuffle(names)).concat(['<span>&copy; NATIVE INSTRUMENTS GMBH</span>']);

        var html = '<div class="credits"><p style="background: #fff"><img src="/typo3conf/ext/ni_assets/Resources/Public/Images/ni-logo.png"/></p></div>';

        $.magnificPopup.open({
            items: {
                src: html,
                type: 'inline'
            }
        });

        setTimeout(function () {
            var credits = $('.credits');
            $(lines).each(function (i) {
                var that = this;
                setTimeout(function () {
                    credits.append($('<p class="credits-animation">' + that + '</p>'));
                }, 1000 * i);
            });
        }, 500);
    }
});